
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{staticClass:"icon-download-arrow",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 14 17","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"icon-fill",attrs:{"d":"M14 6h-4V0H4v6H0l7 7 7-7zM0 15v2h14v-2H0z"}})])
      }
    
      }
    